import React, { FC } from 'react';
import { ProjectId } from 'api/models';
import { useProjectVisibilityConfig } from 'components/molecules/project-details/hooks';
import { ViewSwitcher } from 'components/organisms/tasks/view-switcher';
import { getProjectTaskBoardUrl, getProjectTaskListUrl } from 'utils/urls';

interface ProjectTasksViewSwitcherProps {
  projectId: ProjectId;
}

export const ProjectTasksViewSwitcher: FC<ProjectTasksViewSwitcherProps> = ({
  projectId,
}) => {
  const config = useProjectVisibilityConfig(projectId);

  if (config && config.visibilityMeta.board === false) {
    return null;
  }

  return (
    <div data-preview-enable="true">
      <ViewSwitcher
        listUrl={getProjectTaskListUrl(projectId)}
        boardUrl={getProjectTaskBoardUrl(projectId)}
      />
    </div>
  );
};
